import { PassengerType } from "@b2bportal/core-types";
import type { TFunction } from "i18next";

export const getGuestTypeString = (guestType: PassengerType, t: TFunction) => {
  switch (guestType) {
    case PassengerType.Adult: {
      return t("passengerInformation.adult");
    }
    case PassengerType.InfantInSeat: {
      return t("passengerInformation.infant");
    }
    case PassengerType.InfantInLap: {
      return t("passengerInformation.infant");
    }
    case PassengerType.Child: {
      return t("passengerInformation.child");
    }
  }
};
